import { Component, OnInit, NgZone, Compiler } from '@angular/core';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { HeaderBarComponent } from '../header-bar/header-bar.component';
import { FoodServiceService } from 'app/food-service.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-order-online',
  templateUrl: './order-online.component.html',
  styleUrls: ['./order-online.component.css']
})
export class OrderOnlineComponent implements OnInit {
  ordercategories = [];
  errorMessage = '';
  tastes: any[] = [];
  foods: any[] = [];
  searchParams = {};
  categoryid = '';
  searchfood = '';
  private sub: any;
  sliderValue: any = { price: '' };
  mycartitems: any[] = [];
  private itemsval: number[];
  private priceVal: number;
  subtotal = 0;
  total = 0;
  cart = [];
  shoppingcart = [];
  addclass: any;
  addons: any = [];
  constructor(private CommonService: WebApiObservableService, private zone: NgZone, private _compiler: Compiler, private _Food: FoodServiceService, private routeparams: ActivatedRoute, private router: Router) {

  }

  ngOnInit() {
    $('.spin').addClass('loading');
    this.sub = this.routeparams.params.subscribe(params => {
      this.categoryid = params['id'];

      this._Food.
        getFoods(this.categoryid)
        .subscribe(
        result => { this.foods = result.items; this._compiler.clearCache(); },
        error => { $('.spin').removeClass('loading'); this.foods = <any>error }
        );

    });

    this.shoppingcart = JSON.parse(localStorage.getItem('SHOPPING_CART'));

    if (this.shoppingcart !== null) {
      this.mycartitems = this.shoppingcart[0].fooditems;
      this.subtotal = this.shoppingcart[0].subtotal;
      this.total = this.shoppingcart[0].total;
    }


    if (this.mycartitems.length !== 0) {

      for (var i = 0; i < this.mycartitems.length; i++) {
        this.addclass = this.mycartitems[i].id;
      }
    }
    /*Calling Api for categories */
    this.CommonService
      .getService('/categories')
      .subscribe(
      result => {
        this.ordercategories = result.items
      },
      error => { $('.spin').removeClass('loading'); this.errorMessage = <any>error }
      );


    this.CommonService
      .getService('/tasteoflocations')
      .subscribe(
      result => {
        this.tastes = result;
        $('.spin').removeClass('loading');
      },
      error => { $('.spin').removeClass('loading'); this.errorMessage = <any>error }
      );

  }
  // refresh(){
  //  this.zone.runOutsideAngular(() => {
  //          location.reload();
  //      });
  // }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  OnSelectTaste(id) {

    this.searchParams = {
      status: 1,
      taste_of_location_id: id
    };
    this.CommonService
      .getServiceWithComplexObjectAsQueryString('/categories', this.searchParams)
      .subscribe(
      result => {
        this.ordercategories = result.items;
        this.categoryid = this.ordercategories[0].id;
        this.CommonService
          .search('/foods', 'category', this.categoryid)
          .subscribe(
          result => { this.foods = result.items; this._compiler.clearCache(); },
          error => this.foods = <any>error
          );
      }
      ,
      error => this.errorMessage = <any>error
      );


  }

  /*Function definition for Filters foods according to category id*/
  OnClickFilterFoods(categoryitem) {
    this.categoryid = categoryitem.id;
    this.CommonService
      .search('/foods', 'category', this.categoryid)
      .subscribe(
      result => { this.foods = result.items; this._compiler.clearCache(); },
      error => this.foods = <any>error
      );
  }
  createaddon: any = [];
  addonprice: number = 0;
  foodVar: any;
  AddOnArray(addon, index) {

    if (addon.checked === false) {
      for (var i = 0; i < this.createaddon.length; i++) {
        if (addon.addon_id === this.createaddon[i].addon_id) {
          this.createaddon.splice(i, 1);
          this.addonprice -= addon.price;
        }
      }
    } else if (addon.checked === true) {
      this.createaddon.push(addon)
      this.addonprice += addon.price;
    }
    this.foodVar.priceVal = this.foodVar.price + this.addonprice;
  }

  OnClickAddOn(addonModal) {
    this.mycartitems.push({ food: this.foodVar, addons: this.createaddon });
    $('#foodselect' + this.foodVar.id).addClass('disabledclass');
    $('#foodselectdata' + this.foodVar.id).html('Item Added');
    addonModal.close();
  }
  OnClickCancel(addonModal) {
    this.addonprice = 0;
    this.createaddon = [];
    this.foodVar.priceVal = this.foodVar.price + this.addonprice;
    addonModal.close();
  }

  addToCart(fooddata) {
    this.createaddon = [];
    this.addonprice = 0;
    // this.subtotal = 0;
    // this.total = 0;
    fooddata.itemsval = 1;
    this.foodVar = fooddata;
    $('.spincam').addClass('loading');
    this.CommonService
      .getService('/addons/addon?food_id=' + fooddata.id)
      .subscribe(
      result => {
        this.addons = result.items;
        for (var i = 0; i < this.addons.length; i++) {
          this.addons[i].checked = false;
        }
        if (this.addons.length !== 0) {
          document.getElementById("openModalButton").click();
          this.foodVar.priceVal = this.foodVar.price + this.addonprice;
        } else {
          this.foodVar.priceVal = this.foodVar.price + this.addonprice;
          this.mycartitems.push({ food: this.foodVar, addons: this.createaddon });
          $('#foodselect' + this.foodVar.id).addClass('disabledclass');
          $('#foodselectdata' + this.foodVar.id).html('Item Added');
        }
        $('.spincam').removeClass('loading');
      },
      error => { $('.spincam').removeClass('loading'); this.errorMessage = <any>error }
      );


    // fooddata.priceVal =  fooddata.price + this.addonprice;

    // this.mycartitems.push({ food: fooddata, addons: this.createaddon });

    // $('#foodselect' + fooddata.id).addClass('disabledclass');
    // $('#foodselectdata' + fooddata.id).html('Item Added');
  }
  myaddonsprice: any = 0;
  onPlusitem(index: number) {
    this.mycartitems[index].food.itemsval += 1;
    
    // this.mycartitems[index].food.priceVal = this.mycartitems[index].food.price * this.mycartitems[index].food.itemsval;
    this.mycartitems[index].food.priceVal = this.mycartitems[index].food.priceVal + this.mycartitems[index].food.price;
  }

  onMinusitem(index: number) {
    this.mycartitems[index].food.itemsval -= 1;
    // this.mycartitems[index].food.priceVal = this.mycartitems[index].food.price * this.mycartitems[index].food.itemsval;
    this.mycartitems[index].food.priceVal = this.mycartitems[index].food.priceVal - this.mycartitems[index].food.price;
  }

  calculateSubtotal() {
    this.subtotal = 0;
    for (let i = 0; i < this.mycartitems.length; i++) {
      this.subtotal += this.mycartitems[i].food.priceVal;
    }
    return this.subtotal;
  }

  calculateTotal() {
    this.total = 0;
    for (let i = 0; i < this.mycartitems.length; i++) {
      this.total += this.mycartitems[i].food.priceVal;
    }
    return this.total;
  }

  placeOrder() {
    if (this.mycartitems.length !== 0) {
      this.cart.push({ 'fooditems': this.mycartitems, 'subtotal': this.subtotal, 'total': this.total })

      localStorage.setItem('SHOPPING_CART', JSON.stringify(this.cart));
      this.router.navigate(["cart"]);
    } else {
      alert('Your cart is empty');
    }

  }

  delete(food) {

    const index: number = this.mycartitems.indexOf(food);
    this.mycartitems.splice(index, 1);
    this.addonprice = 0;
    this.subtotal -= food.food.priceVal;
    this.total -= food.food.priceVal;
    $('#foodselect' + food.food.id).removeClass('disabledclass');
    $('#foodselectdata' + food.food.id).html('');

    if (this.mycartitems.length === 0) {
      this.addclass = '';
      localStorage.removeItem('SHOPPING_CART');
    }
  }
  imageData = [];
  openImage(food) {

    document.getElementById("openImage").click();
    this.imageData = food;

  }
}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/order-online/order-online.component.ts